import { Component, OnInit, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { BaseGridEditLineComponent } from '../../shared/base-components/base-grid-editline.component';

import { GlobalsService } from '../../shared/services/globals.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { InventoryService } from '../../shared/services/inventory.service';

import { SaveMode } from '../../shared/enums/SaveMode';

import { EmployHistoryBus } from '../../shared/models/EmployHistory';
import { EmployeeService } from '../../shared/services/employee.service';
import { CommonFunctions } from '../../shared/static/common-functions';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'cp-employ-history',
    templateUrl: './employ-history.component.html',
    styleUrls: ['./employ-history.component.scss'],
    standalone: false
})

export class EmployHistoryComponent extends BaseGridEditLineComponent<EmployHistoryBus, null, EmployeeService>  {

    termReasons: any[] = [{ value: null, description: "" }, { value: "1", description: "Layoff (Temp)" }, { value: "2", description: "Layoff (Perm)" }, { value: "3", description: "Vountary" }, { value: "4", description: "For Cause" }, { value: "5", description: "LOA" }];

    constructor( globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: EmployeeService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;

        this.className = "EmployHistoryBus";
        this.appCode = "EmployHistory";
        this.saveMode = SaveMode.all;
        this.disableCpSearchDialog();

    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'hireDt': new UntypedFormControl(),
            'termDt': new UntypedFormControl(),
            'termReason': new UntypedFormControl(),
            'note': new UntypedFormControl(),
        });

    }
    setForm() {
        var termCode = null;
        if (this.selectedData.termReason) { termCode = this.selectedData.termReason.toString()}
        this.editForm.patchValue({
            hireDt: this.selectedData.hireDt,
            termDt: this.selectedData.termDt,
            termReason: termCode,
            note: this.selectedData.note,

       });
    }

    getTermReason(id: number): string {
        if (!this.termReasons || !id) { return ""; }
        let item = this.termReasons.find(a => a.value === id.toString());

        if (CommonFunctions.hasValue(item)) {
            return item.description;
        }
        return "";
    }

}

